import { type LucideIcon } from "lucide-react";

interface EmptyPlaceholderProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  minHeight?: string;
}

export const EmptyPlaceholder = ({
  icon: Icon,
  title,
  description,
  minHeight = "400px",
}: EmptyPlaceholderProps) => {
  return (
    <div
      className="flex w-full items-center justify-center rounded-lg border border-dashed border-gray-400 p-6"
      style={{ minHeight }}
    >
      <div className="flex flex-col items-center gap-2 text-center">
        <div className="w-fit rounded-lg border border-dashed p-3">
          <Icon size={20} />
        </div>
        <p className="text-base font-medium">{title}</p>
        {description && (
          <p className="mt-1 text-sm text-gray-600">{description}</p>
        )}
      </div>
    </div>
  );
};
